module.exports = __webpack_public_path__ + "img/personal24.6e35e27a.jpeg";